export default "__VITE_ASSET__CNLBiOeV__";